declare let COMPANY_ID: string;
declare let SALES_OFFICE_AREA_ID: string;

export const companyId = parseInt(COMPANY_ID || '624'); // canlı 624
export const salesOfficeAreaId = parseInt(SALES_OFFICE_AREA_ID || '96'); // canlı 96

export const adultAgeInMonths = 144;
export const childAgeInMonths = 24;

export const geographicBoundaryTypeCountryId = 2;

export const maritalStatusIds = {
  SINGLE: 28,
  MARRIED: 27,
  NON_SPECIFIED: 725,
};

export const contactMediumTypeId = {
  EMAIL: 6,
  PHONE: 2,
  ADDRESS: 8,
};
